import { render, staticRenderFns } from "./companyDetail.vue?vue&type=template&id=48268483&scoped=true"
import script from "./companyDetail.vue?vue&type=script&lang=js"
export * from "./companyDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetail.css?vue&type=style&index=0&id=48268483&prod&scoped=true&lang=css&external"
import style1 from "./companyDetail.vue?vue&type=style&index=1&id=48268483&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48268483",
  null
  
)

export default component.exports